import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuIdea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 19H15V18H9V19Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6C12.41 6 12.75 5.66 12.75 5.25C12.75 4.84 12.41 4.5 12 4.5C9.52 4.5 7.5 6.52 7.5 9C7.5 9.41 7.84 9.75 8.25 9.75C8.66 9.75 9 9.41 9 9C9 7.34 10.34 6 12 6Z",
			fill: "#fff"
		})
	]
});
export default SvgMenuIdea;
